export const capitalizar = (texto: string) => texto.charAt(0).toUpperCase() + texto.slice(1);

export const formatCurrency = (value: number) => {
  if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";

  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

// ponytail: mesma conversão do mobile (app-mobile/src/app/chat.tsx#whatsappToMarkdown)
// — o bot responde em formatação estilo WhatsApp (*bold*, ~strike~), não markdown padrão.
// (?!\s)/(?<!\s) nas bordas do conteúdo evita casar o "* " de um bullet list (ex: bot
// respondendo "* *Label:* valor") como se fosse a abertura de um bold — sem essa regra o
// bullet "*" rouba o par do "*Label:*" seguinte e desalinha o resto da mensagem inteira.
export function whatsappToMarkdown(text: string): string {
  return text
    .replace(/```([^`\n][^\n]*)```/g, "`$1`")
    .replace(/(?<!\*)\*(?!\s)([^*\r\n]+?)(?<!\s)\*(?!\*)/g, "**$1**")
    .replace(/(?<!~)~(?!\s)([^~\r\n]+?)(?<!\s)~(?!~)/g, "~~$1~~");
}

export const formatPercentage = (value: number | string) => {
  if (value === null || value === undefined) return "0,00%";

  const cleaned = typeof value === "string" ? value.replace("%", "") : value;
  const num = Number(cleaned);

  if (isNaN(num)) return "0,00%";

  const truncated = Math.trunc(num * 100) / 100;

  return `${truncated.toFixed(2).replace(".", ",")}%`;
};
